import { useState, useEffect } from 'react';
import '../App.css';
/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Square } from './/square';
import { WinComponent } from './/winCompnent';
import { GameConfig } from '../App';

interface GameProps {
  gameConfig: GameConfig;
  restart: () => void;
}

export const Game = (props: GameProps) => {
  const [ width, setWidth ] = useState(props.gameConfig.maxTurns * 10);
  const [ height, setHeight ] = useState(props.gameConfig.maxTurns * 10);
  const [ top, setTop ] = useState(400);
  const [ left, setLeft ] = useState(800);
  const [ playerHasWon, setPlayerHasWon ] = useState(false);

  useEffect(() => {
    if (width <= 0 && height <= 0) {
      setPlayerHasWon(true);
      console.log('WON');
    }
  }, [width, height]);

  const handleTouch = () => {
    console.log('touched!');

    adjustSize();
    adjustPosition();
  };

  const adjustSize = () => {
    const newWidth = width - 10;
    const newHeight = height - 10;
    setWidth(newWidth);
    setHeight(newHeight);

    console.log('new width: ', newWidth);
    console.log('new height: ', newHeight);
  };

  const adjustPosition = () => {
    const randomLeft = Math.floor(Math.random() * (window.innerWidth - 100));
    const randomTop = Math.floor(Math.random() * (window.innerHeight - 100));
    setLeft(randomLeft);
    setTop(randomTop);

    console.log('new left: ', randomLeft);
    console.log('new top: ', randomTop);
  };

  return (
    <div >
        {
          playerHasWon && <WinComponent restart={props.restart} />
        }
        <Square
          color={props.gameConfig.color}
          handleTouch={handleTouch}
          width={width}
          height={height}
          top={top}
          left={left}
        />
    </div>
  );
};
